import { IdentitySection } from './identity-section';
import { DescriptionSection } from './description-section';
import { ImagesSection } from './images-section';
import { StatusVisibilitySection } from './status-visibility-section';

/** Tab 1 — Βασικά Στοιχεία. */
export function BasicInfoTab() {
	return (
		<div className="flex flex-col gap-4">
			<IdentitySection />
			<DescriptionSection />
			<ImagesSection />
			<StatusVisibilitySection />
		</div>
	);
}
